"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HTTPServerErrorCodes = exports.UKFascias = void 0;
const CommonEnums_1 = require("../enums/CommonEnums");
exports.UKFascias = {
    1: 'cotswold',
    2: 'snowandrock',
    3: 'cyclesurgery',
    4: 'runnersneed',
};
exports.HTTPServerErrorCodes = [
    CommonEnums_1.HTTPStatusCode.InternalServerError,
    CommonEnums_1.HTTPStatusCode.NotImplemented,
    CommonEnums_1.HTTPStatusCode.BadGateway,
    CommonEnums_1.HTTPStatusCode.ServiceUnavailable,
    CommonEnums_1.HTTPStatusCode.GatewayTimeout,
    CommonEnums_1.HTTPStatusCode.HTTPVersionNotSupported,
    CommonEnums_1.HTTPStatusCode.VariantAlsoNegotiates,
    CommonEnums_1.HTTPStatusCode.InsufficientStorage,
    CommonEnums_1.HTTPStatusCode.LoopDetected,
    CommonEnums_1.HTTPStatusCode.NotExtended,
    CommonEnums_1.HTTPStatusCode.NetworkAuthenticationRequired,
];
//# sourceMappingURL=GeneralConstants.js.map